<template>
    <div class="w3-margin">
        <div v-if="isNotRole" class="w3-text-red w3-large w3-center">
            Nincs jogosultsága a funkció használatáshoz!
        </div>
        <div v-else>
            <div v-if="$store.getters.isLogin">
                <div class="w3-bar w3-blue-grey">
                    <div class="w3-bar-item w3-padding uppercase">Saját túrák</div>          
                    <div class="w3-right" > 
                        <div class="w3-bar-item w3-hover-blue w3-button">
                            <span v-if="isOnline" class="cursorpointer" title="Új útvonal létrehozása" v-on:click="editHike(null)"> <font-awesome-icon icon="plus-square" ></font-awesome-icon></span>&nbsp;
                        </div>                               
                    </div>
                </div> 
            <table class="w3-table-all w3-small">
                    <tr class="w3-white w3-hide-small">   
                        <td class="w3-large"><font-awesome-icon class="" size="1x" icon="filter"></font-awesome-icon></td>
                        <td></td>
                        <td>
                            <input class="w3-input w3-border" v-model="filter.name">
                        </td>   
                        <td></td>                                                                            
                        <td>
                            <select v-model="filter.status" class="w3-input w3-border">
                                <option value=""></option>
                                <option v-for="(item, index) in $appData.status" :key="index" v-bind:value="item.sign">{{item.name}}</option>
                        </select>
                        </td>
                        <td></td>
                    </tr>                        
                    <tr class="w3-blue-grey">
                        <td class="w3-hide-small">#</td>                                         
                        <td class=""></td> 
                        <td v-on:click="sortBy('name')" class="cursorpointer">
                            Túra neve
                            <font-awesome-icon v-if="sortKey=='name' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                            <font-awesome-icon v-if="sortKey=='name' && reverse=='asc'" icon="angle-down"></font-awesome-icon>
                        </td>                                            
                        <td v-on:click="sortBy('creatdate')" class="w3-center cursorpointer w3-hide-small">
                            Módosítva
                            <font-awesome-icon v-if="sortKey=='creatdate' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                            <font-awesome-icon v-if="sortKey=='creatdate' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                        </td>                      
                        <td v-on:click="sortBy('status')" class="w3-center cursorpointer w3-hide-small">
                            Állapot
                            <font-awesome-icon v-if="sortKey=='status' && reverse=='desc'" icon="angle-up"></font-awesome-icon>
                            <font-awesome-icon v-if="sortKey=='status' && reverse=='asc'" icon="angle-down"></font-awesome-icon>                                
                        </td>                      
                    <td class="w3-center">Menü</td>                 
                    </tr>   
                                        
                    <tr class="cursorpointer" v-for="(item, index) in orderedOwnHikes" :key="index" v-on:click="setGeogo(item)">
                            <td class="w3-hide-small">{{index+1}}.</td>
                            <td v-if="item.status==2" class="w3-text-green w3-center">
                                <span v-if="item.mode==2"><font-awesome-icon icon="bicycle" ></font-awesome-icon></span>
                                <span v-if="item.mode==1"><font-awesome-icon icon="hiking" ></font-awesome-icon></span>
                            </td>                                        
                            <td v-else class="w3-text-red w3-center">
                                <span v-if="item.mode=='2'"><font-awesome-icon icon="bicycle" ></font-awesome-icon></span>
                                <span v-if="item.mode=='1'"><font-awesome-icon icon="hiking" ></font-awesome-icon></span>
                            </td>    
                            <td>{{item.name}}</td>                                                  
                            <td class="w3-center w3-hide-small">{{item.creatdate | filterDateFormat}}</td>
                            <td class="w3-center w3-hide-small">{{item.status | filterStatusToString}}</td>
                            <td class="w3-center" v-on:click.prevent="showMenu(item)">
                                <span v-if="isOnline" title="menü" class="cursorpointer"><font-awesome-icon icon="ellipsis-v"></font-awesome-icon></span>
                            </td> 
                    </tr>
                </table> 
            </div> 

            <div v-if="isMenu" class="w3-modal" style="z-index: 4000; display:block; " v-on:click="closeMenu">
                <div class="w3-modal-content w3-card-4 w3-animate-zoom " style="max-width:400px;">
                    <div class="w3-display-container">
                        <div class="w3-blue w3-padding">{{item.name}}</div>                         
                        <div class="w3-input w3-button" v-on:click="showRoute(item)"><font-awesome-icon icon="eye" ></font-awesome-icon> Előnézet</div>
                        <div class="w3-input w3-button" v-on:click="editHike(item)"><font-awesome-icon class="w3-text-blue" icon="edit"></font-awesome-icon> Túra szerkesztése</div>
                        <div class="w3-input w3-button" v-on:click="deleteHike(item)"><font-awesome-icon class="w3-text-red" icon="trash-alt"></font-awesome-icon> Túra törlése</div>
                    </div>
                </div> 
            </div> 
        </div>                  
    </div>
    
</template>

<script>
const fb = require('../firebase.js');
import {store} from "../store.js";
export default {
    name: 'OwnHikes',
    data() {
        return {
            isNotRole:false,
            sortKey: 'name',
            reverse: 'asc',
            ownHikes: null,           
            isMenu:false,
            item:null,
            filter:{
                "name":"",
                "status":"",
            },                       
        }
    },
    computed: {   
        orderedOwnHikes: function () {
            var orderedList=_.orderBy(this.ownHikes, [this.sortKey], [this.reverse]);
            var filteredList = orderedList.filter((item) => {                
                const nameFilter = (item.name.toLowerCase().indexOf(this.filter.name.toLowerCase())>-1);
                const statusFilter = (item.status==this.filter.status) || (this.filter.status=="");
                return nameFilter && statusFilter;
            });            
            return filteredList;
        },
    },
    methods:{
        showMenu(item){
            this.item=item;
            this.isMenu=true;
        },
        closeMenu(){
            this.isMenu=false;
        },  
        showRoute(item){
            this.$router.push('/routeinfo/'+item.id);
        },       
        setGeogo(item){
            this.$storage.set('actualGeogo', item);
        },              
        sortBy(sortKey) {
            if (this.sortKey == sortKey) {
                if (this.reverse=='asc') this.reverse='desc';
                else this.reverse='asc';
            };
            this.sortKey = sortKey;
        },
        editHike(hike){
            this.$storage.set('modHike', hike);
            this.$router.push('/createhike');
        },
        deleteHike(hike){
                this.$showSpinner();
                fb.GetHikeCertifyesCount(hike.id).then(count=>{
                    this.$hideSpinner();
                    if (count>0) {
                        this.$dialog.alert(this.$setDialogMsg('w3-yellow','Figyelmeztetés','Ez a túra ('+hike.name+') nem törölhető, mert már van teljesítője.'));
                    } else {
                        let self = this;
                        this.$dialog.confirm(this.$setDialogMsg("w3-yellow","Törlés","Biztosan törlöd ezt a túrát ("+hike.name+")?"))
                        .then(function(dialog) {                      
                            self.$showSpinner();
                            fb.DeleteHike(hike.id).then(res=>{  
                                self.$hideSpinner();  
                                self.getOwnHikes();
                                self.$dialog.alert(self.$setDialogMsg('w3-green','Törlés','A túra törlése megtörtént.'));                             
                            }).catch(e=>{
                                console.log(e);                            
                                self.$hideSpinner();
                                self.$dialog.alert(self.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a túra törlése során.'));
                            })
                        }); 
                    }
                }).catch(e=>{
                    console.log(e);                
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt a törlés során.'));
                }); 
        },
        getOwnHikes(){
                this.$showSpinner();            
                fb.GetAllGeogoToAdmin().then(res=>{
                    this.ownHikes = res;
                    this.$hideSpinner();
                }).catch(e=>{
                    console.log(e);                
                    this.$hideSpinner();
                    this.$dialog.alert(this.$setDialogMsg('w3-red','Hibaüzenet','Hiba történt az adatok betöltése során.'));
                }); 
        },         
    },
    mounted() {
        if (this.$store.getters.userProfile){
            if (fb.IsRouteAdmin(this.$store.getters.userProfile.uid)) {
                if (this.isOnline) {
                    this.getOwnHikes();
                }
            } else this.isNotRole=true;
        } else this.isNotRole=true;
    },    
}
</script>

